// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1bf2fc4f","81":"22607b22","186":"27490880","344":"e0baa02c","372":"aef73c54","612":"b0be2b4f","630":"c993079c","841":"4a025667","856":"d50db95d"}[chunkId] + ".chunk.js";
};